export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_SOLICITATIONS':
      return { solicitations: action.solicitations };
    default:
      return state;
  }
};
